import styled from "styled-components";

import { Button as LibButton } from "@ui/Atoms";

export const Button = styled(LibButton).attrs({
  type: "button",
  size: "large",
})`
  width: fit-content;
  min-height: 0;
  padding: 0 ${({ theme }) => theme.margins.base_x2};
  height: ${({ theme }) => theme.buttons.sizes.pill};
`;
